import {CookieConsent} from '../declarations';

/* -------------------- Constants -------------------- */
export const COOKIE_STORAGE_KEY = 'es₂bɘ_cookie_consent';
export const COOKIE_CONSENT_VERSION = '1.0';
export const COOKIE_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

/* -------------------- Default Consent -------------------- */
export const createDefaultConsent = (): CookieConsent => ({
    necessary: true,
    media: false,
    timestamp: Date.now(),
    version: COOKIE_CONSENT_VERSION,
});

/* -------------------- Read / Validate Consent -------------------- */
export const readStoredConsent = (): CookieConsent | null => {
    try {
        const raw = localStorage.getItem(COOKIE_STORAGE_KEY);
        if (!raw) return null;
        const {timestamp, version, ...rest}: CookieConsent = JSON.parse(raw);
        const isExpired = Date.now() - timestamp > COOKIE_MAX_AGE_MS;
        const isStaleVersion = version !== COOKIE_CONSENT_VERSION;
        if (isExpired || isStaleVersion) return null;
        return {timestamp, version, ...rest};
    } catch {
        return null;
    }
};

/* -------------------- Write Consent -------------------- */
export const writeConsent = (consent: CookieConsent): void => {
    localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(consent));
    window.dispatchEvent(
        new CustomEvent('cookieConsentChanged', {detail: consent}),
    );
};

/* -------------------- Reset Consent -------------------- */
export const resetConsent = (): void => {
    localStorage.removeItem(COOKIE_STORAGE_KEY);
};
